<template>
  <div class="scroll-container">
    <el-carousel
      v-if="bannerList.length"
      class="banner-container"
      height="260px"
      :arrow="bannerList.length > 1 ? 'hover' : 'never'"
      :indicator-position="bannerList.length > 1 ? '' : 'none'"
      :interval="5000"
    >
      <el-carousel-item v-for="item in bannerList" :key="item.appBannerPk" @click.native="clickBanner(item)">
        <img :src="item.appBannerMediaUrl" :alt="item.appBannerTitle" class="banner-img">
      </el-carousel-item>
    </el-carousel>

    <div v-if="jumpBannerList.length" class="banner-jump">
      <div v-for="(item, index) in jumpBannerList" :key="index" :class="`banner-item-${index + 1} has-cursor`" @click="handleJump(item)">
        <img :src="item.blockLineMediaUrl || item.defaultBlockMediaUrl">
      </div>
    </div>

    <ul v-if="navList.length" class="navs-wrap flex-between">
      <li v-for="(item, index) in navList" :key="index">
        <AppItem v-if="item" :data="item"></AppItem>
      </li>
    </ul>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { setToken } from '@/helpers/auth'

import AppItem from '@/components/AppItem'

export default {
  name: 'Index',
  components: { AppItem },
  data() {
    return {
      loadingComponent: null,
      isLoading: false,
      bannerList: [],
      jumpBannerList: []
    }
  },
  computed: {
    navList() {
      const list = this.$store.getters.currApps.WKS || []
      // 补余
      const index = list.length % 4
      if (index !== 0) {
        for (let i = 0; i < 4 - index; i++) {
          list.push('')
        }
      }
      return list
    },
    accountInfo() {
      return this.$store.getters.accountInfo
    },
    currCustomer() {
      return this.$store.getters.currCustomer
    },
    currDcpRoles() {
      return this.$store.getters.currDcpRoles
    }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    }
  },
  mounted() {
    this.fetchBanner()
    this.fetchJumpBanner()
  },
  methods: {
    dataTracking(tmp) {
      this.$api.login.dataTracking(tmp).then(res => {

      }).catch(err => {
        console.log(err)
      })
    },
    clickBanner(item) {
      this.gtag('event', 'usr_click_carousel', {
        'value': item.appBannerCode
      })
      this.gtag('event', `usr_click_carousel_${item.appBannerCode}`)
      const tmp = {
        eventName: 'view_webpage',
        targetType: 'BANNER',
        targetPk: item.appBannerPk,
        agentType: 'PC',
        params: item.appBannerCode,
        uuid: this.accountInfo.accountUuid,
        customerNumber: this.currCustomer.customerNumber,
        roleCode: this.currDcpRoles[0].roleCode
      }
      this.dataTracking(tmp)

      this.$router.push({
        path: '/bannerDetail',
        query: {
          targetType: 'BANNER',
          targetPk: item.appBannerPk,
          agentType: 'PC',
          params: item.appBannerCode,
          uuid: this.accountInfo.accountUuid,
          customerNumber: this.currCustomer.customerNumber,
          roleCode: this.currDcpRoles[0].roleCode,
          hasWatermark: item.watermarkFlag,
          watermarkText: this.accountInfo.accountId
        }
      })
    },
    fetchBanner() {
      const data = {
        programType: this.currCustomer.programType,
        customerNumber: this.currCustomer.customerNumber,
        roleCode: this.currDcpRoles[0].roleCode
      }
      this.isLoading = true
      this.$api.message.getBannerList(data).then(res => {
        this.isLoading = false
        this.bannerList = res.data
      }).catch(() => {
        this.isLoading = false
      })
    },
    fetchJumpBanner() {
      const data = {
        blockSubCategory: 'PC',
        programType: this.currCustomer.programType,
        roleCode: this.currDcpRoles[0].roleCode
      }
      this.isLoading = true
      this.$api.message.getJumpBannerList(data).then(res => {
        this.isLoading = false
        if (this.checkJump(res.data)) {
          this.jumpBannerList = res.data || []
        } else {
          this.jumpBannerList = []
        }
      }).catch(() => {
        this.isLoading = false
      })
    },
    getApps() {
      const appMap = {}
      const currApps = this.$store.getters.currApps
      for (const key in currApps) {
        if (Object.hasOwnProperty.call(currApps, key)) {
          const list = currApps[key] || []
          list.forEach(item => {
            appMap[item.applicationCode] = item.applicationRedirectUri
          })
        }
      }
      return appMap
    },
    checkJump(list) {
      if (list) {
        const appMap = this.getApps()
        for (let i = 0; i < list.length; i++) {
          if (list[i].blockLineJumpAppCode !== null && list[i].blockLineJumpAppCode !== '') {
            if (!Object.keys(appMap).includes(list[i].blockLineJumpAppCode) || !appMap[list[i].blockLineJumpAppCode]) {
              return false
            }
          }
        }
      }
      return true
    },
    handleJump(item) {
      if (!item) return

      const appMap = this.getApps()
      if (!Object.keys(appMap).includes(item.blockLineJumpAppCode) || !appMap[item.blockLineJumpAppCode]) {
        return
      }

      const dcpToken = Cookies.get('dcp-token')
      // 比对
      if (dcpToken !== this.$store.getters.token) {
        this.$confirm('您已被登出', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          customClass: 'dcp-message-box',
          confirmButtonClass: 'dcp-message-box-confirm-btn',
          cancelButtonClass: 'dcp-message-box-cancel-btn'
        })
          .then(() => {
            this.$router.push('/login')
          })
          .catch(() => {})
        return
      }

      this.checkToken(item, appMap[item.blockLineJumpAppCode]).then((url) => {
        this.isLoading = false
        const newWindow = window.open('about:blank', '_blank')
        // 修改新窗口的url
        newWindow.blur()
        newWindow.opener.focus()
        newWindow.location.href = url
      })
    },
    checkToken(item, jumpUrl) {
      let accessToken = Cookies.get('accessToken')
      let bizType = ''
      if (accessToken) {
        // accessToken未过期
        bizType = ''
      } else {
        // accessToken过期被删除
        bizType = 'refresh_ids_access_token'
      }

      return new Promise((resolve) => {
        this.isLoading = true
        const params = {
          bizType: bizType,
          transport: {
            params: {
              blockLineJumpAppCode: item.blockLineJumpAppCode,
              blockLineJumpAppName: item.blockLineJumpAppName,
              blockLineJumpUrl: item.blockLineJumpUrl
            }
          }
        }
        this.$api.login
          .checkToken(params)
          .then((res) => {
            console.log('===', res)
            // this.isLoading = false
            if (res.data.accessToken) {
              // accessToken过期，新数据替换
              // 替换token
              setToken(res.data.token)
              // 设置accessToken
              accessToken = res.data.accessToken
              let date = new Date().getTime()
              date += res.data.accessTokenTimeout * 1000
              const accessTokenTimeout = new Date(date)
              Cookies.set('accessToken', res.data.accessToken, {
                expires: accessTokenTimeout
              })

              this.$store.dispatch('user/SET_ACCESS_TOKEN', {
                token: res.data.token,
                accessToken: res.data.accessToken,
                accessTokenTimeout: res.data.accessTokenTimeout
              })
            }
            if (res.data.agreements && res.data.agreements.length > 0) {
              this.$store.dispatch('user/SET_AGREEMENTS', res.data.agreements)
              return
            }
            resolve(
              `${jumpUrl}?access_token=${accessToken}`
            )
          })
          .catch(() => {
            this.isLoading = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.scroll-container {
  /deep/ .el-scrollbar__wrap {
    height: calc(100vh - 80px - 50px - 50px - 50px);
  }
}

.banner-container {
  width: 100%;
  height: 260px;
  border-radius: 4px;
  overflow: hidden;
  background: #f4f4f4;
  cursor: pointer;

  .banner-img {
    width: 100%;
    height: 100%;
  }
}

.banner-jump {
  margin: 0 0 30px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .has-cursor {
    cursor: pointer;
  }
  .banner-item-1 {
    width: 49.3%;
    height: 0;
    position: relative;
    padding-bottom: 23.3%;
  }
  .banner-item-2 {
    width: 49.3%;
    height: 0;
    position: relative;
    padding-bottom: 23.3%;
  }
  .banner-item-3 {
    margin-top: 1.3%;
    width: 100%;
    height: 0px;
    position: relative;
    padding-bottom: 23.3%;
  }
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.navs-wrap {
  flex-wrap: wrap;
  // padding: 24px 0;

  li {
    width: 184px;
    margin-top: calc((766px - 184px*4) / 3);
  }
}
</style>
